import { Document, Page, Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

Font.register({
    family: 'Poppins',
    fonts: [
        {
            src: '/fonts/Poppins-Regular.ttf',
            fontWeight: 'normal',
        },
        {
            src: '/fonts/Poppins-SemiBold.ttf',
            fontWeight: 600,
        },
        {
            src: '/fonts/Poppins-Bold.ttf',
            fontWeight: 'bold',
        },
    ],
});

// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 20,
    },
    col: {
        display: "flex",
        flexDirection: "row",
        //border: "1px solid black",
    }
});


function AnnualBatchReport({ data }) {
    const annualbatch = Array.isArray(data) ? data : [];

        function formatDate(dateInput) {
            const date = new Date(dateInput);
            const day = String(date.getDate()).padStart(2, '0');       // 06
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = monthNames[date.getMonth()];                 // Aug
            const year = date.getFullYear();                           // 2014

            return `${day}-${month}-${year}`;
        }

    return (
        <Document>
            <Page orientation="landscape" style={{ padding: 30, fontSize: 10, }}>

                <View style={[styles.row, { textAlign: "center", fontSize: "10px", border: "1px solid black" }]}>
                    <View style={{ width: "100%", textAlign: "center", padding: "5px" }}>
                        <Text style={{ fontFamily: "Poppins", fontWeight: "bold" }}>ANNUAL BATCH PLAN FOR THE YEAR - 2025 - 2026</Text>
                    </View>
                </View>


                <View style={[styles.col, { width: "100%", borderBottom: "1px solid black", fontSize: "10px", textAlign: "center", }]}>

                    <View style={{ borderLeft: "1px solid black", borderRight: "1px solid black", width: "5%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>Sr.No.</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "15%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}> Training Programme</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "5%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}> Batch No.</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "10%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}> Category </Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "10%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>Timings</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "8%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}> Planned Start Date </Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "8%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>Actual Start Date</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "8%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}> Last Date of Admision</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "12%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>Training Completion Date</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "8%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>Duration</Text>
                    </View>
                    <View style={{ borderRight: "1px solid black", width: "12%" }}>
                        <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>Traning Coordinator</Text>
                    </View>

                </View>
                {annualbatch.map((item, index) => (
                    <View style={[styles.col, { width: "100%", borderBottom: "1px solid black", fontSize: "10px", textAlign: "center", }]}>

                        <View style={{ borderLeft: "1px solid black", borderRight: "1px solid black", width: "5%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{index + 1}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "15%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{item.Course_Name}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "5%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{item.Batch_code}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "10%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{item.Category}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "10%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{item.Timings}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "8%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{formatDate(item.SDate)}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "8%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{formatDate(item.ActualDate)}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "8%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{formatDate(item.Admission_Date)}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "12%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{formatDate(item.EDate)}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "8%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{item.Duration}</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "12%" }}>
                            <Text style={{ textAlign: "center", fontSize: 8, fontFamily: "Poppins" }}>{item.Training_Coordinator}</Text>
                        </View>

                    </View>
                ))}




            </Page>
        </Document>

    )
}

export default AnnualBatchReport